import React from 'react';
import { CustomToolTip } from 'shared-one-ux-components';
import { SdfBadge } from '@synerg/react-components';

export default function ClientProjectTitle({ projectDetails, hasBadge }) {
	return (
		<div className='flex flew-row items-center'>
			<div className='text-heading-06 mr-2 max-w-3/4'>
				<CustomToolTip text={projectDetails.clientName} startEllipsisLen='21' width="100%"/>
			</div>
			{hasBadge && <SdfBadge className='ml-2' status='new'>New</SdfBadge>}
		</div>
	)
}
